
function getFontWeight(bold) {
    return { fontWeight: bold ? "700" : "normal" }
}

export {
    getFontWeight
}